
export default class Facebook {
  constructor (user) {
    this.user = user
  }
  connection () {
    const adsSdk = require('facebook-nodejs-business-sdk')
    const api = adsSdk.FacebookAdsApi.init(this.user.token)
    const account = new adsSdk.AdAccount(this.user.selectedAdAccount)
    return { adsSdk, api, account }
  }
  SdkClass () {
    return {
      Campaign: this.connection().adsSdk.Campaign,
      AdAccount: this.connection().adsSdk.AdAccount,
      AdSet: this.connection().adsSdk.AdSet,
      Ad: this.connection().adsSdk.Ad,
      CustomAudience: this.connection().adsSdk.CustomAudience
    }
  }
}
